const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const classNames = require('classnames');

// @ utils
const { formatText } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');
const { getPublicSitePathByLanguaje } = require('core/apiURLBuilder');
const { getUrlDocumentByEncodedId } = require('utilities/pdfDocumentsHelper');
const storage = require('utilities/storage');

// @ commons
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { RadioButton } = require('commonsComponents/radioButton');
const { StarsRating } = require('commonsComponents/starsRating');
const RiskLevelBar = require('components/broker/commons/riskLevelBar/riskLevelBar');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @constants
const {
    BROKER_SEARCH_RESULTS_TOTAL_STARS,
    BROKER_SEARCH_RESULTS_TOTAL_RISK,
    BROKER_HIRE_PENSION_PLAN_URL,
    DISPLAY_WATCHLIST_TOOLTIP_BY_DEFAULT,
    PRODUCT_TYPE_PLAN
} = require('constants/index');

class BrokerAdvancedSearchPlansResultsRow extends React.Component {
    constructor(props) {
        super(props);
        this.handleCheckChange = this.handleCheckChange.bind(this);
        this.handleProductSelect = this.handleProductSelect.bind(this);
    }

    shouldComponentUpdate(next) {
        return this.props.isActive !== next.isActive || this.props.item.get('watchlistId') !==next.item.get('watchlistId');
    }

    componentWillUnmount() {
        storage.localStorage.set(DISPLAY_WATCHLIST_TOOLTIP_BY_DEFAULT, 1);
    }

    handleCheckChange(e) {
        this.props.saveCheckedList(e.target.id);
    }

    handleProductSelect(product) {
        this.props.onHandleProductSelect(product);
    }

    handlePdfDownload(pdfUrl){
        return ()=>window.open(pdfUrl, '_blank');
    }

    buildCheckboxCell(item) {
        const { isActive, fromPlansTransfer } = this.props;
        let checkbox;

        checkbox = fromPlansTransfer ? (
            <OKTableCell>
                <RadioButton
                    className="broker-search-results__radio"
                    onChange={this.handleProductSelect}
                    isChecked={isActive}
                    id={item.get('secId')}
                    name={item.get('name')}
                    value={item.get('secId')}
                />
            </OKTableCell>
            )
        : (
            <OKTableCell>
                <OKCheckbox
                    extraClass="broker-search-results__checkbox"
                    idName={item.get('secId')}
                    onChange={this.handleCheckChange}
                    value={isActive}
            />
            </OKTableCell>
            );
        return checkbox;
    }

    buildBuySection(buyUrl, buyLabel, watchlistBtnTooltip, buyButtonSize, watchlistButton){
        const watchlistBtn = storage.localStorage.get(`watchlistTooltipFlag`) === 1 ? watchlistBtnTooltip : watchlistButton;
        
        if (this.props.fromPlansTransfer) {
            return null;
        } else {
            return (
                <OKTableCell className="broker-search-results__table-cell--action">
                    <div className="broker-search-results__action-group">
                        {watchlistBtn}
                        <OKButton
                            modifier="secondary"
                            to={buyUrl}
                            size={buyButtonSize}
                        >
                            {buyLabel}
                        </OKButton>
                    </div>
                </OKTableCell>
            );
        }
    }

    render() {
        const { item, rowIndex, watchlistEnabled } = this.props;
        const notAvailableText = formatText('broker-searchResultsNotAvailableData');
        const buyLabel = watchlistEnabled ? formatText(`broker-searchResultsWatchListBuyLabel`) : formatText(`broker-searchResultsBuyLabel`);
        const buyButtonSize = watchlistEnabled ? "small" : "regular";
        const TOTAL_STARS = BROKER_SEARCH_RESULTS_TOTAL_STARS;
        const TOTAL_RISK = BROKER_SEARCH_RESULTS_TOTAL_RISK;

        const risk = item.get('risk') ? (
            <RiskLevelBar
                riskLevel={item.get('risk')}
                maxLevel={TOTAL_RISK}
            />
        ) : notAvailableText;
        const isin = item.get('secId');
        const miccode = item.get('dgsCode');

        const buyUrl = BROKER_HIRE_PENSION_PLAN_URL+item.get('CustomInstitutionSecurityID');
        const cardUrl = getPublicSitePathByLanguaje('brokerURL-brokerURL_pensionPlanOnPublic', {miccode})
        const url = getUrlDocumentByEncodedId(item.get('KiidDocument'));
        const watchlistId = item.get('watchlistId');
        const productKey = item.get('productKey');
        const productName = item.get('name');
        const starIconClasses = classNames('broker-search-results__star', {
            'broker-search-results__star--disabled': !watchlistId
        });

        const watchlistButton = (
            <span>
                <OKButton
                    modifier="ghost"
                    size="small"
                    autoHeight={true}
                    onClick={() => { !watchlistId ? this.props.onWatchlistClick(isin, miccode, PRODUCT_TYPE_PLAN, productKey) : this.props.deleteProductFromList(watchlistId, isin, miccode, productName, watchlistId, false, PRODUCT_TYPE_PLAN, productKey)}}
                >
                    <i className={starIconClasses}></i>
                </OKButton>
            </span>
        );
        const watchListToolTipInitialVal = Number(storage.localStorage.get(DISPLAY_WATCHLIST_TOOLTIP_BY_DEFAULT)) === 0;
        const isTooltipVisible = (rowIndex == 0 && watchListToolTipInitialVal && watchlistEnabled);
        const watchlistBtnTooltip = watchlistEnabled && (
            <OKTooltip
                target={watchlistButton}
                content="brokerWatchList-brokerWatchList_tooltip"
                isVisible={isTooltipVisible}
            />
        );

        const checkbox = this.buildCheckboxCell(item);
        const buyCell = this.buildBuySection(buyUrl, buyLabel, watchlistBtnTooltip, buyButtonSize, watchlistButton);

        const tableRow = (
            <OKTableRow>
                {checkbox}
                <OKTableCell
                    className="broker-search-results__table-cell broker-search-results__table-first-column broker-search-results__table-cell--bold"
                >
                    <OKLink to={cardUrl}>{item.get('name')}</OKLink>
                </OKTableCell>
                <OKTableCell>
                    {item.get('category') || notAvailableText}
                </OKTableCell>
                <OKTableCell alignment="center">
                    <StarsRating
                        total={TOTAL_STARS}
                        actual={item.get('rating')}
                        customClassName="broker-search-results__stars-rating"
                    />
                </OKTableCell>
                <OKTableCell alignment="center">
                    {risk}
                </OKTableCell>
                <OKTableCell alignment="right">
                    {formatAmount(item.get('ytd'))}
                </OKTableCell>
                <OKTableCell alignment="right">
                    {formatAmount(item.get('aYear'))}
                </OKTableCell>
                <OKTableCell alignment="right">
                    {formatAmount(item.get('threeYears'))}
                </OKTableCell>
                <OKTableCell
                    alignment="right"
                    className="broker-search-results__table-header-cell--plan-five-year"
                >
                    {formatAmount(item.get('fiveYears'))}
                </OKTableCell>
                <OKTableCell alignment="center">
                    <OKButton
                        modifier="tasks"
                        size="small"
                        loaderColor="dark"
                        loaderSize="small"
                        onClick={this.handlePdfDownload(url)}>
                        <i className="icon icon-descargar account-debits-detail__icon-descargar" />
                    </OKButton>
                </OKTableCell>
                {buyCell}
            </OKTableRow>
        )
        return tableRow;
    }
}

BrokerAdvancedSearchPlansResultsRow.propTypes = {
    item: PropTypes.object,
    checkedList: PropTypes.object,
    saveCheckedList: PropTypes.func,
    onWatchlistClick: PropTypes.func,
    isActive: PropTypes.bool,
    deleteProductFromList: PropTypes.func,
    fromPlansTransfer: PropTypes.bool,
    onHandleProductSelect: PropTypes.func,
    rowIndex: PropTypes.number,
    watchlistEnabled: PropTypes.bool
}

module.exports = BrokerAdvancedSearchPlansResultsRow;
